import { RatingMethod } from '@shared/generated/graphql';
import { BothRatesRatingWidget } from './BothRatesRatingWidget/BothRatesRatingWidget';
import { CustomerRatesRatingWidget } from './CustomerRatesRatingWidget/CustomerRatesRatingWidget';
import { LegacyRatingWidget } from './LegacyRatingWidget';
import { RatingWidgetProps } from './types';

export function RatingWidget(p: RatingWidgetProps) {
  switch (p.ratingMethod) {
    case RatingMethod.ARCBEST_TL_QUOTING:
      return <CustomerRatesRatingWidget {...p} hideWhenNoErrors />;
    case RatingMethod.WERNER:
      return <CustomerRatesRatingWidget {...p} />;
    case RatingMethod.AVRL:
    case RatingMethod.FASTMORE: {
      return <BothRatesRatingWidget {...p} />;
    }
    default:
      // TODO(mike): Remove the legacy widget in a future refactor.
      return <LegacyRatingWidget {...p} />;
  }
}
